import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';

import { DataService } from '../../../services/data.service';
import { LocaleService } from '../../../services/locale.service';

@Component({
  selector: 'app-cronologia-pratica',
  templateUrl: './cronologia-pratica.component.html',
  styleUrls: ['./cronologia-pratica.component.css']
})
export class CronologiaPraticaComponent implements OnInit {
	@Input() data: any = null;
	@Output() innerEvents = new EventEmitter();
	@Input() writePermission: boolean = false;

	readOnly: boolean = true;
	selectedLogPratica: any = null;

	num_logs: any = 0;
	num_dettagli = 0;
	notifica_spese_agg: any = 0;
	oneri_risc: any = 0;
	spese_esecutive: any = 0;

	logPratiche: any[] = [];
	logPraticheDettagli: any[] = [];
	logSync: boolean = false;
	logPraticheSync: Subscription;

	comune: any = null;
	comuneSync: Subscription;

	parametri: any = {
		ricalcolaRettifica: false,
		ricalcolaSanzioni: false,
	};
	parametriString: string = '{}';

	selectedRow: string = '';
	infoPratica: any = {};
	dettagliPratica: any[] = [];

	constructor(private dataService: DataService, private formatter: LocaleService) {}

	ngOnInit() {
		this.comuneSync = this.dataService.getComuniService().comune$.subscribe(
			(comune) => {
				this.comune = comune;
		});
		this.logPraticheSync = this.dataService.logPratiche$.subscribe(
			logPratiche => {
				this.logPratiche = this.dataService.getLogPraticheByUid(this.data.uid);
				this.reset();
				this.fillSummedAttributePratica();
				console.log("CRONOLOGIA|log_pratica 1:", this.logPratiche);
				this.logSync = true;
			});
	}

	ngOnChanges(changes: any){
		console.log("CRONOLOGIA|ngchange:", this.logSync, this.data.uid, changes);
		if (changes.data) {
			if(changes.data.currentValue.uid && this.data.uid > 0){
				this.parametriString = JSON.stringify(this.parametri);
				this.logPratiche = this.dataService.getLogPraticheByUid(this.data.uid);
				this.readOnly = this.data.readOnly;
				this.reset();
				this.fillSummedAttributePratica();
				console.log("CRONOLOGIA|log_pratica 2:", this.logPratiche, " uid:", this.data.uid);
				this.onSelect(this.logPratiche);
			}
		}
	}

	setSelectedRow() {
		this.logPraticheDettagli = this.dataService.getLogPraticaDettagliByLogPratica(this.selectedLogPratica);
		let selectedRow = {
			infoPratica : this.selectedLogPratica,
			dettagliPratica : this.logPraticheDettagli
		}
		console.log('CRONOLOGIA|SETSELECTEDROW:', selectedRow);
		this.selectedRow = JSON.stringify(selectedRow);
	}

	reset(){
		if(this.logPratiche)
			this.num_logs = this.logPratiche.length;
		if(this.num_logs)
			this.onSelect(this.logPratiche[this.num_logs-1]);
	}

	fillSummedAttributePraticaDettagli(){
		this.num_dettagli = 0;
		this.oneri_risc = 0.00;

		for(let row of this.logPraticheDettagli){
			this.notifica_spese_agg += Number(row.notifica_spese);
			this.oneri_risc += Number(row.oneri_risc_attuali);
			this.num_dettagli++;
		}
	}

	fillSummedAttributePratica(){
		this.spese_esecutive = 0.00;
		this.notifica_spese_agg = 0.00;
		this.spese_esecutive = Number(this.selectedLogPratica.diritti_pf_agg) + Number(this.selectedLogPratica.diritti_pf_agg_prec);
		this.notifica_spese_agg += Number(this.selectedLogPratica.notifica_spese_agg) + Number(this.selectedLogPratica.notifica_spese_agg_prec);
	}

	hide(){
		let event:any = {
			hide : true
		}
		this.reset();
		this.innerEvents.emit(event);
	}

	onSelect(row: any){
		console.log('CRONOLOGIA|ONSELECT 1', row, row.log_pratica_id);
		if(row){
			this.selectedLogPratica = row;
			this.setSelectedRow();
			console.log('CRONOLOGIA|ONSELECT 2', this.selectedLogPratica, this.selectedLogPratica.log_pratica_id);
		}
	}

	restorePratica(row: any){
		if(row){
			let event: any = {
				hide : true,
				restorePratica: true,
				uid: this.data.uid,
				id_log_pratica: row.log_pratica_id
			}
			this.reset();
			this.innerEvents.emit(event);
		}
	}

	ngOnDestroy() {
		this.comuneSync.unsubscribe();
	}
}
